function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import * as React from 'react';
import './emoji-manager.scss';
import 'emoji-picker-element';
import { BetterInput } from '../better-input/better-input';
import { SmileOutlined } from '@ant-design/icons';
import { Input, Popover } from 'antd';
import * as randomstring from 'randomstring';
import { fireNativeInputChangeEvent, getClassNames } from '../../utils';
import { default as GraphemeSplitter } from 'grapheme-splitter';
import { MacroManager } from '../macro-manager/macro-manager';
import { useRefState, useListenerEvent } from '../../hooks';
var splitter = new GraphemeSplitter();

/**
 * Returns the actual html input element
 * whether nested or direct
 *
 */
function getInputElement(ref) {
  var _ref$current;
  var hasMacroManager = childHasMacroManager(ref);
  var current = hasMacroManager ? (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.inputComponentRef : ref.current;
  var inputConstructor = current === null || current === void 0 ? void 0 : current.constructor;
  var isHtmlInput = inputConstructor !== Input && inputConstructor !== BetterInput;
  return isHtmlInput ? current : current === null || current === void 0 ? void 0 : current.input;
}
function childHasMacroManager(ref) {
  var _ref$current2;
  return ((_ref$current2 = ref.current) === null || _ref$current2 === void 0 ? void 0 : _ref$current2.constructor) === MacroManager;
}
var BASE_CLASSNAME = 'emoji-manager';
var EmojiManager = function EmojiManager(_ref) {
  var children = _ref.children,
    hideToggle = _ref.hideToggle,
    disabled = _ref.disabled;
  var inputRef = React.useRef(undefined);
  var componentId = React.useRef("em-".concat(randomstring.generate({
    length: 5
  })));
  var _useRefState = useRefState(false),
    _useRefState2 = _slicedToArray(_useRefState, 2),
    showEmojiOptions = _useRefState2[0],
    setShowEmojiOptions = _useRefState2[1];
  var InputComponent = React.Children.only(children);

  /**
   * Determines whether click is blur or focus.
   * Uses component unique id to prevent collisions.
   *
   */
  var handleDocumentClick = function handleDocumentClick(ev) {
    var toEl = ev.target;
    if (toEl) {
      // determine if clicked element is inside
      // the current macro manager scope
      // only true external clicks should close
      var masterEl = toEl.closest("#".concat(componentId.current));
      var overlayEl = toEl.closest(".".concat(componentId.current));
      var shouldClose = !masterEl && !overlayEl;
      // computed blur events should clear
      // input state and hide macro options
      if (shouldClose) {
        setShowEmojiOptions(false);
      }
    }
  };

  /**
   * Handles focus, keyup, and click events for the
   * inputComponent.
   *
   * Gathers current inputContext and updates state
   *
   */
  var handleInputInteraction = function handleInputInteraction(ev) {
    var _ev$stopPropagation, _ev$stopImmediateProp;
    (_ev$stopPropagation = ev.stopPropagation) === null || _ev$stopPropagation === void 0 ? void 0 : _ev$stopPropagation.call(ev);
    (_ev$stopImmediateProp = ev.stopImmediatePropagation) === null || _ev$stopImmediateProp === void 0 ? void 0 : _ev$stopImmediateProp.call(ev);
    var shouldShowEmojiOptions = false;
    try {
      var evType = ev.type;
      shouldShowEmojiOptions = evType === 'mousedown' && showEmojiOptions.current;
    } catch (err) {
      console.warn('Error computing input state', err);
    }
    setShowEmojiOptions(shouldShowEmojiOptions);
  };
  var handleEmojiSelection = function handleEmojiSelection(ev, emoji) {
    var element = getInputElement(inputRef);
    if (element) {
      var _element$selectionSta, _emoji$emoji$length, _emoji$emoji;
      var selectionStart = (_element$selectionSta = element.selectionStart) !== null && _element$selectionSta !== void 0 ? _element$selectionSta : 0;
      var value = element.value;
      value = value || '';
      var splitValue = splitter.splitGraphemes(value);
      var expandedLength = 0;
      var insertIdx = splitValue.findIndex(function (g) {
        expandedLength += g.length;
        return expandedLength >= selectionStart;
      });
      splitValue.splice(insertIdx === 0 && insertIdx === selectionStart ? insertIdx : insertIdx + 1, 0, emoji.emoji);
      fireNativeInputChangeEvent(element, splitValue.join(''));
      var selection = selectionStart + ((_emoji$emoji$length = (_emoji$emoji = emoji.emoji) === null || _emoji$emoji === void 0 ? void 0 : _emoji$emoji.length) !== null && _emoji$emoji$length !== void 0 ? _emoji$emoji$length : 0);
      element.selectionStart = selection;
      element.selectionEnd = selection;
      element.focus();
    }
  };
  var clickCallback = React.useCallback(function (ev) {
    handleDocumentClick(ev);
  }, [componentId.current]);
  var inputCallback = React.useCallback(function (ev) {
    handleInputInteraction(ev);
  }, [showEmojiOptions.current]);
  var handlePickerClick = React.useCallback(function (ev) {
    if (ev.detail) {
      handleEmojiSelection(ev, {
        emoji: ev.detail.unicode
      });
    }
  }, [componentId.current]);
  var addPickerListener = React.useCallback(function () {
    setTimeout(function () {
      var picker = document.querySelector("emoji-picker.".concat(componentId.current));
      picker === null || picker === void 0 ? void 0 : picker.addEventListener('emoji-click', handlePickerClick);
    }, 10);
  }, [componentId.current]);
  var removePickerListener = React.useCallback(function () {
    var picker = document.querySelector("emoji-picker.".concat(componentId.current));
    picker === null || picker === void 0 ? void 0 : picker.removeEventListener('emoji-click', handlePickerClick);
  }, [componentId.current]);
  useListenerEvent('click', clickCallback, document.body);
  useListenerEvent('mousedown', inputCallback, getInputElement(inputRef));
  useListenerEvent('keydown', inputCallback, getInputElement(inputRef));
  return /*#__PURE__*/React.createElement("div", {
    key: componentId.current,
    id: componentId.current,
    className: getClassNames(BASE_CLASSNAME, componentId.current, {
      'overlay-visible': showEmojiOptions.current,
      'hide-toggle': hideToggle,
      disabled: disabled
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassNames("".concat(BASE_CLASSNAME, "-input-wrapper"))
  }, /*#__PURE__*/React.createElement(InputComponent.type, _extends({}, InputComponent.props, {
    ref: function ref(el) {
      // call initial ref method
      var _ref2 = InputComponent,
        ref = _ref2.ref;
      if (ref && typeof ref === 'function') {
        ref(el);
      }

      // set internal ref
      inputRef.current = el;
    },
    className: getClassNames("".concat(BASE_CLASSNAME, "-input"), InputComponent.props.className)
  })), /*#__PURE__*/React.createElement(Popover, {
    overlayClassName: getClassNames("".concat(BASE_CLASSNAME, "-emoji-overlay"), componentId.current),
    trigger: "click",
    visible: showEmojiOptions.current,
    onVisibleChange: function onVisibleChange(v) {
      if (!v) {
        removePickerListener();
      }
    },
    placement: "bottomLeft",
    content: /*#__PURE__*/React.createElement("div", {
      className: getClassNames("".concat(BASE_CLASSNAME, "-emoji-picker-react"))
    }, /*#__PURE__*/React.createElement("emoji-picker", {
      "class": "light ".concat(componentId.current)
    }))
  }, /*#__PURE__*/React.createElement("span", {
    className: getClassNames("".concat(BASE_CLASSNAME, "-emoji-toggle"))
  }, /*#__PURE__*/React.createElement(SmileOutlined, {
    onClick: function onClick(ev) {
      ev.stopPropagation();
      ev.preventDefault();
      var visible = !showEmojiOptions.current;
      setShowEmojiOptions(visible);
      if (visible) {
        addPickerListener();
      }
    }
  })))));
};
export default EmojiManager;